import { Button, ButtonGroups } from "@nocios/presentation-kit";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Config from "src/Constants/Config";
import store from "src/Reducers/store";
import setCurrentPage from "src/Utils/setCurrentPage";

const PageId = 14;
const BackPageId = 0;

const DATA = () => {
  const currentPage = useSelector(() => store.getState().appReducer.currentPage);
  const [step, setStep] = useState(0);

  const baseImageUrl = `${Config.BASE_URL}/images/screen_${PageId}/`;
  const rightSideImage_1 = `${baseImageUrl}animation_1.png`;
  const rightSideImage_2 = `${baseImageUrl}animation_2.png`;
  const rightSideImage_3 = `${baseImageUrl}animation_3.png`;
  const rightSideImage_4 = `${baseImageUrl}animation_4.png`;
  const rightSideImage_5 = `${baseImageUrl}animation_5.png`;
  const rightSideImage_6 = `${baseImageUrl}animation_6.png`;

  const rightSideComponentBaseStyle: React.CSSProperties = {
    position: "absolute",
    right: 0,
    bottom: 0,
    transition: "opacity .6s ease-in-out",
    height: "100%",
  };

  useEffect(() => {
    let timeoutId: any;
    if (currentPage === PageId) {
      if (step === 0) timeoutId = setTimeout(() => setStep(step + 1), 200);
    } else setStep(0);

    return () => {
      setStep(0);
      clearTimeout(timeoutId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  const stepsTime = [400, 400, 400, 400, 400, 400, 400];

  useEffect(() => {
    let timeoutId: any;
    if (step > 0 && step <= stepsTime.length) timeoutId = setTimeout(() => setStep(step + 1), stepsTime[step - 1]);

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step]);

  const nextButtonConfig = {
    label: "Finish",
    type: "next",
    onClick: () => setCurrentPage(1),
    style: { gap: "var(--width-16)" },
  };

  return {
    bgVideo: {
      video: `${Config.BASE_URL}/videos/bg_${PageId}.mp4`,
      poster: `${Config.BASE_URL}/images/BG/bg_${PageId}.jpg`,
    },
    styleBody: {
      marginTop: "var(--width-155)",
    },
    title: "BOOSTING BUSINESS IMPACT WITH\nTHE CONNECTIVITY PLATFORM",
    styleTitle: {
      color: "#FFF",
      fontFamily: "Tungsten",
      fontSize: "var(--width-64)",
      fontStyle: "normal",
      fontWeight: 350,
      lineHeight: "var(--height-71)",
      textTransform: "uppercase",
    },
    description:
      "As telecom providers face increasing pressure to enhance\ncustomer satisfaction and drive operational efficiencies,\nthe <b>Infosys Connectivity Platform</b> delivers actionable\nsolutions, unlocking measurable ROI and sustainable\ngrowth.",
    styleDescription: {
      color: "#FFF",
      fontFamily: "Myriad Pro",
      fontSize: "var(--width-24)",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "140%",
      marginTop: "var(--width-18)",
    },
    rightSideComponent: (
      <>
        <img src={rightSideImage_1} alt="" style={{ ...rightSideComponentBaseStyle, opacity: step >= 1 ? 1 : 0 }} />
        <img src={rightSideImage_2} alt="" style={{ ...rightSideComponentBaseStyle, opacity: step >= 2 ? 1 : 0 }} />
        <img src={rightSideImage_3} alt="" style={{ ...rightSideComponentBaseStyle, opacity: step >= 3 ? 1 : 0 }} />
        <img src={rightSideImage_4} alt="" style={{ ...rightSideComponentBaseStyle, opacity: step >= 4 ? 1 : 0 }} />
        <img src={rightSideImage_5} alt="" style={{ ...rightSideComponentBaseStyle, opacity: step >= 5 ? 1 : 0 }} />
        <img src={rightSideImage_6} alt="" style={{ ...rightSideComponentBaseStyle, opacity: step >= 6 ? 1 : 0 }} />
      </>
    ),
    next: nextButtonConfig,
  };
};

export default DATA;
